
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import List from './List.vue'
export default{
data () {
return {
messages: [],
show: false
}
},
components: {Popup, PopupHeader, XButton, List},
created () {
this.$store.state.bus.$on('get-user-info', this.load)
setInterval(this.load, 600 * 1000)
},
methods: {
load () {
this.$refs.list.load()
},
onLoaded (data) {
this.messages = data.results
this.show = this.messages.length > 0 && this.$route.name !== 'message_message_list'
},
onDone () {
let ids = this.messages.map(m => m.id) 
this.$http.post('/message/message/batch_read/', {batch_action_ids: ids}).then(({data}) => {
this.load()
})
}
}
}



// WEBPACK FOOTER //
// ./src/views/message/message/components/Popup.vue